import Joi from "joi";
import { circleBg, facebookIcon, googleIcon, stepsBg } from "../../constants/images";
import { useDictionary } from "../../contexts/dictionary";
import { Col, HeroBanner, List, ListItem, Row, Text, Title, VerticalSeparator, VImage } from "../../style/base.style";
import { Colors } from "../../style/colors";
import { FieldType, TextFieldType } from "../fields";
import { FormComponent } from "../form";
import { VerticalSepWithTitle } from "../common/verticalSepWithTitle";
import { Link } from "react-router-dom";
import { useDeviceType } from "../../contexts/DeviceContext";

interface QuickSignupProps {
  description?: string;
  benefits?: string[];
}

export const QuickSignup = ({description,benefits}:QuickSignupProps) => {
     const {translate} = useDictionary()
     const {isMobile} = useDeviceType()

     const signupBenefits:any[] = benefits || ["membership_priority","membership_quick_access","membership_signup"]
    
      const registerFields: FieldConfig[] = [
        {
          type: FieldType.text,
          name: "Full_Name",
          label: translate("name"),
          joiSchema: Joi.string().pattern(/^\s*\S+\s+\S+\s*$/).message('Must contain exactly two words').required(),
          typeOptions: {
            type: TextFieldType.text,
          }
        },
        {
          type: FieldType.text,
          name: "Email",
          label: translate("email_label"),
          joiSchema: Joi.string().email({ tlds: { allow: false } }).required(),
          typeOptions: {
            type: TextFieldType.text,
          }
        },
        
        {
          type: FieldType.text,
          name: "password",
          label: translate("password_label"),
          joiSchema: Joi.string().required(),
          typeOptions: {
            type: TextFieldType.password,
          }
        },
      ]
    
    return (
        <HeroBanner $backgroundImage={circleBg} $background={Colors.primary} $padding="35px 0">
            <Row $width="90%" $justifyContent="center" $alignItems="flex-start">
                <Col $width={isMobile?"100%":"60%"} $alignItems={isMobile?"center":"flex-start"} >
                <Title $color={Colors.whiteBackground} $fontSize={36} $margin="20px 0">{translate("signup_now")}</Title>
                           <Text $color={Colors.whiteBackground} $fontSize={'20px'}>{translate(description || "membership_title")}</Text>
                           <Col $width="100%" $alignItems="flex-start" $justifyContent="flex-start" $padding="20px 0">
                           <List>
                             {
                               signupBenefits.map((item, index) => {
                                 return (
                                   <ListItem $color={Colors.whiteBackground} $fontSize={20} key={index}>{translate(item)}</ListItem>
                                 )
                               })
                             }
                             
                           </List>
                           </Col>
               
                           
                </Col>
                <Col $width={isMobile?"100%":"25%"}>
                    <FormComponent
                    fields={registerFields}
                    title={isMobile?"":translate("register")}
                    onChange={()=>{}}
                    serverRes={null}
                    theme="dark"
                    />
                    <VerticalSepWithTitle title={translate('or_signup_with')} color={Colors.whiteBackground}/>
                    <Row>
                    <Link to="#">
                        <Col $width="45px" $height="45px" $backgroundColor={Colors.whiteBackground} $border={`1px solid ${Colors.whiteBackground}`} $borderRadius={5} $padding="10px 10px" $margin="15px 5px">
                            <VImage
                                    src={googleIcon}
                                    alt="google-icon"
                                    />
                         </Col>       
                    </Link>

                    <Link to="#">
                        <Col $width="45px" $height="45px" $backgroundColor={Colors.whiteBackground} $border={`1px solid ${Colors.whiteBackground}`} $borderRadius={5} $padding="10px 10px" $margin="15px 5px">
                            <VImage
                                    src={facebookIcon}
                                    alt="facebook-icon"
                                    />
                         </Col>       
                    </Link>
                          
                    </Row>
                </Col>
            </Row>

        </HeroBanner>
    )
};